export default __webpack_public_path__ + "static/media/products-shefali-lincoln-unsplash.4cc62466.jpg";